import { defineMessages } from 'react-intl';

const messages = defineMessages({
  appHeader: {
    id: 'ApplicationHeader.AppHeader',
    defaultMessage: 'UNFI Product Information',
  },
  searchPlaceholder: {
    id: 'ApplicationHeader.SearchPlaceholder',
    defaultMessage: 'Search…',
  },
  itemSearchTooltip: {
    id: 'ApplicationHeader.ItemSearchTooltip',
    defaultMessage: 'Item Search',
  },
  helpTooltip: {
    id: 'ApplicationHeader.HelpTooltip',
    defaultMessage: 'Help',
  },
});

export default messages;
